/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Fraction } from './Fraction';
const AssignmentDefaultGradingScalePointsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('ASSIGNMENT_DEFAULT_GRADING_SCALE_POINTS'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(Fraction)],
]);
export class AssignmentDefaultGradingScalePointsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentDefaultGradingScalePointsSettingParser.decode(input).map(res => new AssignmentDefaultGradingScalePointsSetting(res));
    }
    static unsafeDecode(input) {
        return AssignmentDefaultGradingScalePointsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentDefaultGradingScalePointsSettingParser.encode(data);
    }
    static schema() {
        return AssignmentDefaultGradingScalePointsSettingParser.schema();
    }
}
